import {
  UninitializedPropertyAccessException8qin22n38p0w as UninitializedPropertyAccessException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function throwUninitializedPropertyAccessException(name) {
  throw UninitializedPropertyAccessException().new_kotlin_UninitializedPropertyAccessException_egi92l_k$('lateinit property ' + name + ' has not been initialized');
}
function throwUnsupportedOperationException(message) {
  throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_chzcdl_k$(message);
}
//region block: exports
export {
  throwUninitializedPropertyAccessException as throwUninitializedPropertyAccessException14fok093f3k3t,
  throwUnsupportedOperationException as throwUnsupportedOperationException2oe5w0ywo7zbr,
};
//endregion

//# sourceMappingURL=ThrowHelpers.mjs.map
